    import axiosAuth from '../../../shared/configs/axios-auth'
    import router from '@/router'
    const getDefaultState = () => {
        return {
            trash: null,
            users: [],
            authMessage: "",
            accountCreated: null,
            loggedIn: false,
            userName: '',
            userMail: '',
            idToken: null,
            userId: null,
            errorCode: null,
            logOutTimer: null,
            resetOk: false,
            verificationSent: false,
            emailVerified: null,
            userInformations: null,
            userCreated: null,
            resetEmailSent: false,
            registerEmailSent: false,
        }
    }

    const state = getDefaultState()

    const getters = {
        authMessage: state => {
            return state.authMessage;
        },
        accountCreated: state => {
            return state.accountCreated;
        },
        userId: state => {
            return state.userId;
        },
        users: state => {
            return state.users;
        },
        userCreated: state => {
            return state.userCreated;
        },
        emailVerified: state => {
            return state.emailVerified;
        },
        verificationSent: state => {
            return state.verificationSent;
        },
        loggedIn: state => {
            return state.loggedIn;
        },
        userName: state => {
            return state.userName;
        },
        userMail: state => {
            return state.userMail;
        },
        authError: state => {
            return state.errorCode;
        },
        logOutTimer: state => {
            return state.logOutTimer;
        },
        resetOk: state => {
            return state.resetOk;
        },
        idToken: state => {
            return state.idToken
        },
        userInformations: state => {
            return state.userInformations
        },
        resetEmailSent: state => {
            return state.resetEmailSent
        },
        registerEmailSent: state => {
            return state.registerEmailSent
        },
    }
   
    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        authMessage: (state, payload) => {
            state.authMessage = payload
        },
        trash: (state, payload) => {
            state.trash = payload
        },
        users: (state, payload) => {
            state.users = payload
        },
        userCreated: (state, payload) => {
            state.userCreated = payload
        },
        accountCreated: (state, bool) => {
            state.accountCreated = bool
        },
        emailVerified: (state, bool) => {
            state.emailVerified = bool
        },
        verificationSent: (state, bool) => {
            state.verificationSent = bool
        },
        loggedIn: (state, bool) => {
            state.loggedIn = bool;
        },
        resetOk:(state, bool) => {
            state.resetOk = bool
        },
        logOut: (state) => {
            state.loggedIn = false;
            state.userName = null
        },
        userName: (state, payload) => {
            state.userName = payload
        },
        authUser (state, userData) {
            state.idToken = userData.token
            state.userId = userData.userId
            state.userName = userData.userName
            state.loggedIn = true
        },
        authError (state, error) {
            state.errorCode = error
        },
        userInformations (state, error) {
            state.userInformations = error
        },
        resetEmailSent (state, payload) {
            state.resetEmailSent = payload
        },
        registerEmailSent (state, payload) {
            state.registerEmailSent = payload
        },
        clearAuthData (state) {
            state.idToken = null
            state.userName = null
            state.userId = null
            state.logOutTimer = null
            clearInterval(this.interval)
            state.resetOk = false
        }
    }

    const actions = {

        tryAutoLogin ({commit, dispatch}) {
            var token = localStorage.getItem('token')
            if(token){
                if(token.length > 10) {
                    dispatch('userInformations')
                    state.idToken = token
                    commit('authUser', {
                        token: token
                    })
                    axiosAuth.defaults.headers["Authorization"] = token
                    return
                }
            }else{
                if(localStorage.getItem('darkMode')){
                    commit('darkMode', !localStorage.getItem('darkMode'))
                }
                dispatch('logout')       
            }
            
        },

        signup ({commit}, authData) {
            commit('accountCreated', null)
            commit('authError', null)
            commit('authMessage', '')
            commit('updating', true)
            axiosAuth.post('/authbo/register', {
                email: authData.email,
                password: authData.password,
                betakey: authData.betakey
                })
                .then(
                res => {
                    commit('registerEmailSent', res)
                    commit('updating', false)
                    commit('accountCreated', true)
                }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('authMessage', error.response.data)
                    commit('accountCreated', false)
                    commit('authError', error.response.status)
                    commit('updating', false)
                }
                )
        },

        resetPassword ({commit}, authData) {
            commit('accountCreated', null)
            commit('authError', null)
            commit('authMessage', '')
            commit('updating', true)
            axiosAuth.post('/authbo/resetpassword', {
                email: authData.email,
                })
                .then(
                res => {
                    commit('resetEmailSent', res)
                    commit('updating', false)           
                }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('authMessage', error.response.data)
                    commit('authError', error.response.status)
                    commit('updating', false)
                }
                )
        },

        userInformations ({commit, dispatch}) {
            commit('accountCreated', null)
            commit('authError', null)
            commit('authMessage', '')
            commit('updating', true)
            axiosAuth.get('/users/me')
                .then(
                res => {
                    commit('updating', false) 
                    commit('userInformations', res.data)
                    //commit('loggedIn', true)   
                }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('authMessage', error.response.data)
                    commit('authError', error.response.status)
                    commit('updating', false)
                    dispatch('logout')
                }
                )
        },

        resetPasswordConfirm({commit}, payload){ 
            commit('updating', true)
            axiosAuth.post('authbo/reset_password_confirm/', {
              uid: payload.uid,
              token: payload.token,
              new_password: payload.new_password,
              re_new_password: payload.re_new_password
            }).then(
              res => {
                  commit('updating', false)
                  localStorage.setItem('token', res.data.token)
                  router.push({path: '/'})
                }
            )
            .catch(
              error => {
                  commit('updating', false)
                  if(error.response){
                      console.log('response data: ', error.response)
                      commit('authError', error.response)
                      if(error.response.data.token){
                        commit('authMessageActivation', error.response.data.token)
                      }
                      if(error.response.data.token){
                        
                        commit('authMessageResetpassword', error.response.data.token)
                      }

                      if(error.response.data.password){
                        commit('authMessagePassword', error.response.data.password[0])
                      }
                  }else{
                      console.log('error request: ',error.request)
                  }
        
              }
            )
        },

        updateUserInformations: ({commit}, payload) => {
            commit('userCreated', null)
            axiosAuth.patch('/users/me', payload)
            .then(
                res => {
                    commit('userCreated', true)
                    commit('trash', res)
                    commit('updating', false)
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('userCreated', false)
                    commit('updating', false)
                }
            ) 
        },

        login ({commit, dispatch}, authData) {
            commit('authError', null)
            commit('authMessage', '')
            commit('updating', true)
            axiosAuth.post('/authbo/login' , {
                email: authData.email,
                password: authData.password
            })
            .then(
                res => {
                    commit('loggedIn', true)
                    commit('resetState')
                    state.idToken = res.data.token
                    commit('authUser', {
                        token: res.data.token,
                        userId: res.data.id,
                        userMail: res.data.email,
                        userName: res.data.name
                    })                   

                    localStorage.setItem('token', res.data.token)
                    axiosAuth.defaults.headers["Authorization"] = res.data.token;
                    
                    dispatch('userInformations')
                    commit('updating', false)
                    router.push('/dashboard').catch(err => console.log(err.what))                             
                }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                    commit('authError', error.response.status)
                    commit('authMessage', error.response.data)
                }
                )
            },

            logout ({commit}) {
                    var cookie = false

                    if(localStorage.getItem('cookie')){
                        cookie = true
                    }

                    localStorage.clear()
                    if(cookie){
                        localStorage.setItem('cookie', true)
                    }


                    commit('resetState')
                    commit('loggedIn', false)
                    //commit('clearAuthData')
                    commit('updating', false)
                    router.push('/home').catch(() => console.log('err'))
            },

            activateAccount ({commit, dispatch}, authData) {
                commit('authError', null)
                commit('authMessage', '')
                commit('updating', true)
                axiosAuth.post('/authbo/activateaccount' , {
                    token: authData.token
                })
                .then(
                    res => {
                        commit('loggedIn', true)
                        commit('resetState')
                        state.idToken = res.data.token
                        commit('authUser', {
                            token: res.data.token,
                            userId: res.data.id,
                            userMail: res.data.email,
                            userName: res.data.name
                        })                   
    
                        localStorage.setItem('token', res.data.token)
                        axiosAuth.defaults.headers["Authorization"] = res.data.token;
                        
                        dispatch('userInformations')
                        commit('updating', false)
                        router.push('/dashboard').catch(err => console.log(err.what))                             
                    }
                    )
                    .catch(
                    error => {
                        console.log(error.response)
                        commit('updating', false)
                        commit('authError', error.response.status)
                        commit('authMessage', error.response.data)
                    }
                    )
                },
        }

        export default {
            state,
            getters,
            mutations,
            actions
        }
